import Vue from 'vue'
import Router from 'vue-router'
// 百度统计
import ba from 'vue-ba'
import Cookies from 'js-cookie'
// 同步路由参数
import { sync } from 'vuex-router-sync'
// vuex 仓库
import store from '../vuex/store'
// 缓存处理
import cache from '../common/cache'
// url处理
import url from '../common/url'
import util from '../common/util'
import { urlRedirect } from '@/common/urlRedirect'
import { getStoreConfig, getLoginInfo, setInitData, setToken, chooseStore } from '@/common/help'

// 路由配置
import routeConfig from './config'
import vueResource from 'vue-resource'
Vue.use(ba, 'fe0e1e3d0a34b80ce8c1eb2b11355209')
//
Vue.use(Router)
Vue.use(vueResource)
// 缓存store_id
saveStoreId()
// 构造路由
let router = new Router(routeConfig)
let isInit = false
// 路由钩子
// S 转场动画
let historyCount = cache.getSessionData('count') * 1 || 0
cache.setSessionData('/', 0)
const commit = store.commit || store.dispatch
router.beforeEach(async (to, from, next) => {
  // 推送相关旧页面可能不存在，重定向到新地址
  urlRedirect[to.path] && (window.location = `${urlRedirect[to.path]}`)
  if (!isInit) {
    await setToken()
    const [isAuthenticated, _, wxAuthUrl] = await getLoginInfo()
    // 微信登录
    if (!isAuthenticated) {
      window.location.href = wxAuthUrl
      return
    }

    const storesData = await getStoreConfig()
    const storeIds = storesData.stores_config.map(item => item.store_id.toString()) || []
    const cacheStoreId = cache.getLocalStorageData('last_store_id')
    // const cacheStoreId = Cookies.get('last_store_id')
    const isSingleStore = storesData.stores_config.length === 1
    // 如果只有一个店就自动选择第一个店铺，多店使用历史最新操作的店铺id
    const curStoreId = isSingleStore || !storeIds.includes(cacheStoreId) ? storesData.stores_config[0].store_id : cacheStoreId
    let needInit = false

    isInit = true
    // 判断，如果去向页面不是选择门店，则自动登录。
    if (!to.path.includes('choose_store')) {
      // 自动选门店前，需要先退出登录。
      await chooseStore(curStoreId)
      // 更新店铺信息
      await getStoreConfig({ t: Date.now() })
      needInit = true
    }

    if (needInit) {
      await setInitData()
    }
  }
  
  let meta = to.meta || {}
  let titleKey = ''
  if (meta.titles && Object.keys(meta.titles).find) {
    titleKey = Object.keys(meta.titles).find(val => {
      return to.path.endsWith(val)
    })
  }
  // 路由变化，修改title
  if (meta && meta.title) {
    // let title = (meta.titles && meta.titles[to.path]) || meta.title
    let title = (meta.titles && meta.titles[titleKey]) || meta.title
    util.changeTitle(title)
  }
  // 转场动画方向控制
  const toIndex = cache.getSessionData(to.path)
  const fromIndex = cache.getSessionData(from.path)
  if (toIndex) {
    if (toIndex > fromIndex) {
      commit('UPDATE_DIRECTION', 'forward')
    } else {
      commit('UPDATE_DIRECTION', 'reverse')
    }
  } else {
    ++historyCount
    cache.setSessionData('count', historyCount)
    to.path !== '/' && cache.setSessionData(to.path, historyCount)
    commit('UPDATE_DIRECTION', 'forward')
  }
  // loading 动画
  if (meta && meta.needLoading) {
    store.commit('UPDATE_LOADING', {
      status: true,
      text: '加载中...'
    })
  }
  next()
})
sync(store, router)
// E 转场动画
// 页面渲染完毕后关闭loading
router.afterEach(function (to, from) {
  // 记录路由跳转前的 URL 页面信息
  // 服务于数据埋点，[进入页面来源] 关键字段
  from.meta.eventTrackName && cache.setPrevActivePage(from.meta.eventTrackName)

  let env = process.env.NODE_ENV
  // 百度 pv 统计
  if (env === 'production') {
    ba.trackPageview(to.path)
  }
  // 判断是否需要展示loading界面
  if (to.meta && to.meta.needLoading) {
    window.setTimeout(() => {
      store.commit('UPDATE_LOADING', {
        status: false
      })
    }, 1000)
  }
})
// 缓存storeId
function saveStoreId () {
  let storeId = url.getSearch().store_id || ''
  if (storeId) {
    cache.setLocalStorageData(cache.keyMap.CACHE_STORE_ID, storeId)
  }
}
export default router
